/**
 * 장비 룩 레이어. 플레이어 프레임(48×30)과 같은 캔버스에 모자·옷·망토를 그린다.
 */

import { PLAYER_FRAME } from './player';
import { blank, ellipse, px, rect, type Grid } from './grid';

const OX = 14;
const OY = 4;

export const GEAR_LOOK_ART: Record<string, () => Grid> = {
  'look-cap': () => {
    const g = blank(PLAYER_FRAME.width, PLAYER_FRAME.height);
    ellipse(g, OX + 10, OY + 4, 6.2, 3.2, 'q');
    rect(g, OX + 4, OY + 6, 13, 2, 'q');
    return g;
  },
  'look-top': () => {
    const g = blank(PLAYER_FRAME.width, PLAYER_FRAME.height);
    rect(g, OX + 6, OY + 14, 8, 6, 'q');
    rect(g, OX + 4, OY + 15, 2, 4, 'q');
    rect(g, OX + 14, OY + 15, 2, 4, 'q');
    return g;
  },
  'look-bottom': () => {
    const g = blank(PLAYER_FRAME.width, PLAYER_FRAME.height);
    rect(g, OX + 7, OY + 20, 3, 5, 'q');
    rect(g, OX + 11, OY + 20, 3, 5, 'q');
    return g;
  },
  'look-shoes': () => {
    const g = blank(PLAYER_FRAME.width, PLAYER_FRAME.height);
    rect(g, OX + 6, OY + 25, 4, 2, 'q');
    rect(g, OX + 11, OY + 25, 4, 2, 'q');
    return g;
  },
  'look-gloves': () => {
    const g = blank(PLAYER_FRAME.width, PLAYER_FRAME.height);
    px(g, OX + 5, OY + 19, 'q');
    px(g, OX + 15, OY + 19, 'q');
    return g;
  },
  'look-cape': () => {
    const g = blank(PLAYER_FRAME.width, PLAYER_FRAME.height);
    ellipse(g, OX + 9, OY + 18, 5, 7, 'q');
    return g;
  },
};
